import { FC } from "react";

const Privacy: FC = () => {
    return (
        <div className="privacy">
            <h2>Privacy</h2>
            <p>This app dose not collect any user data and dose not sell any data to any 3rd party companies.</p>
        </div>
    );
}
 
export default Privacy;